// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/SourceHanSansSC-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/JingNanBoBoHei.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Source Han Sans SC';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Source Han Sans SC';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'JingNan BoBo Hei';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
html {
  font-size: 16px;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: auto;
  overflow-y: scroll;
  -webkit-text-size-adjust: 100%;
     -moz-text-size-adjust: 100%;
          text-size-adjust: 100%;
}
body {
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #585858;
  background-color: #f5f5f5;
  line-height: 1.5;
  -webkit-tap-highlight-color: transparent;
  min-width: 0;
  overflow-x: auto;
}
a {
  text-decoration: none;
  color: inherit;
}
button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
}
input,
textarea {
  font-family: inherit;
  outline: none;
}
img {
  max-width: 100%;
  height: auto;
  display: block;
}
ul,
ol {
  list-style: none;
}
@media (min-width: 1024px) {
  html {
    overscroll-behavior: none;
  }
}
#root {
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  min-width: 0;
}
.container {
  max-width: 75rem;
  margin: 0 auto;
  padding: 0 1rem;
}
@media (max-width: 767px) {
  .container {
    padding: 0 0.5rem;
  }
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.mt-xs {
  margin-top: 0.25rem;
}
.mt-sm {
  margin-top: 0.5rem;
}
.mt-md {
  margin-top: 1rem;
}
.mt-lg {
  margin-top: 1.5rem;
}
.mb-xs {
  margin-bottom: 0.25rem;
}
.mb-sm {
  margin-bottom: 0.5rem;
}
.mb-md {
  margin-bottom: 1rem;
}
.mb-lg {
  margin-bottom: 1.5rem;
}
.font-display {
  font-family: 'JingNan BoBo Hei', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
.font-sans-bold {
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/styles/fonts.less","webpack://./src/styles/index.less","webpack://./src/styles/reset.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACCF;ADEA;EACE,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACAF;ADGA;EACE,+BAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACDF;ACpBA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;ADsBF;ACnBA;EACE,eAAA;EACA,+EAAA;EACA,mCAAA;EACA,kCAAA;EAEA,gBAAA;EACA,kBAAA;EACA,8BAAA;KAAA,2BAAA;UAAA,sBAAA;ADoBF;ACjBA;EACE,+EAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,wCAAA;EACA,YAAA;EACA,gBAAA;ADmBF;AChBA;EACE,qBAAA;EACA,cAAA;ADkBF;ACfA;EACE,oBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;ADiBF;ACdA;;EAEE,oBAAA;EACA,aAAA;ADgBF;ACbA;EACE,eAAA;EACA,YAAA;EACA,cAAA;ADeF;ACZA;;EAEE,gBAAA;ADcF;AE/CE;EAAA;IFfE,yBAAA;EAkEF;AACF;AA9DA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAgEF;AA5DA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AA8DF;AEjFE;EAAA;IFsBE,iBAAA;EA+DF;AACF;AA3DA;EACE,kBAAA;AA6DF;AA1DA;EACE,gBAAA;AA4DF;AAzDA;EACE,iBAAA;AA2DF;AAxDA;EACE,mBAAA;AA0DF;AAvDA;EACE,kBAAA;AAyDF;AAtDA;EACE,gBAAA;AAwDF;AArDA;EACE,kBAAA;AAuDF;AApDA;EACE,sBAAA;AAsDF;AAnDA;EACE,qBAAA;AAqDF;AAlDA;EACE,mBAAA;AAoDF;AAjDA;EACE,qBAAA;AAmDF;AAhDA;EACE,mGAAA;AAkDF;AA/CA;EACE,+EAAA;EACA,gBAAA;AAiDF","sourcesContent":["@font-face {\n  font-family: 'Source Han Sans SC';\n  src: url('../assets/fonts/SourceHanSansSC-Bold.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Source Han Sans SC';\n  src: url('../assets/fonts/SourceHanSansSC-Bold.otf') format('opentype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'JingNan BoBo Hei';\n  src: url('../assets/fonts/JingNanBoBoHei.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n","@import './variables.less';\n@import './fonts.less';\n@import './mixins.less';\n@import './reset.less';\n\nhtml {\n  .desktop({\n    overscroll-behavior: none;\n  });\n}\n\n// 全局样式\n#root {\n  min-height: 100vh;\n  min-height: 100dvh;\n  width: 100%;\n  min-width: 0;\n}\n\n// 容器\n.container {\n  max-width: 75rem; // 1200px\n  margin: 0 auto;\n  padding: 0 @spacing-md;\n\n  .mobile({\n    padding: 0 @spacing-sm;\n  });\n}\n\n// 通用工具类\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.mt-xs {\n  margin-top: @spacing-xs;\n}\n\n.mt-sm {\n  margin-top: @spacing-sm;\n}\n\n.mt-md {\n  margin-top: @spacing-md;\n}\n\n.mt-lg {\n  margin-top: @spacing-lg;\n}\n\n.mb-xs {\n  margin-bottom: @spacing-xs;\n}\n\n.mb-sm {\n  margin-bottom: @spacing-sm;\n}\n\n.mb-md {\n  margin-bottom: @spacing-md;\n}\n\n.mb-lg {\n  margin-bottom: @spacing-lg;\n}\n\n.font-display {\n  font-family: @font-family-display;\n}\n\n.font-sans-bold {\n  font-family: @font-family-sans;\n  font-weight: 700;\n}\n\n","* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-size: 16px;\n  font-family: @font-family-sans;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  // 缩放后内容超出视口时可滚动（避免仅 overflow:hidden 导致裁切）\n  overflow-x: auto;\n  overflow-y: scroll;\n  text-size-adjust: 100%;\n}\n\nbody {\n  font-family: @font-family-sans;\n  font-weight: 400;\n  color: @text-color;\n  background-color: @background-color;\n  line-height: 1.5;\n  -webkit-tap-highlight-color: transparent;\n  min-width: 0;\n  overflow-x: auto;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n}\n\ninput,\ntextarea {\n  font-family: inherit;\n  outline: none;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\nul,\nol {\n  list-style: none;\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
